export default {
    dpDataList: function () {
        if(this.$store.state.gupiaolist_dp) {
            return this.$store.state.gupiaolist_dp.result;
        }
        return null;
    },
    gpDataList: function () {
        if(this.$store.state.gp_keys_sz) {
            return Object.freeze(this.$store.state.gp_keys_sz);
        }
        return null;
    },
    cyDataList: function () {
        if(this.$store.state.gp_keys_cy) {
            return Object.freeze(this.$store.state.gp_keys_cy);
        }
        return null;
    },
    zxDataList: function () {
        if(this.$store.state.gp_keys_zx) {
            return Object.freeze(this.$store.state.gp_keys_zx);
        }
        return null;
    },
    kcDataList: function () {
        if(this.$store.state.gp_keys_kc) {
            return Object.freeze(this.$store.state.gp_keys_kc);
        }
        return null;
    },
    ziDataList: function () {
        if(this.$store.state.gp_keys_zi) {
            return Object.freeze(this.$store.state.gp_keys_zi);
        }
        return null;
    }
}
